// Recalculates the +N overflow pill for collection swatches on mobile.
// On desktop the Liquid-rendered pill is used as-is (max 7 visible).
// On mobile we hide swatches 6+ via CSS and update the pill count to reflect that.

(function () {
  var MOBILE_BREAKPOINT = 749;
  var DESKTOP_MAX = 7;
  var MOBILE_MAX = 5;

  function updateSwatchPills() {
    var isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

    document.querySelectorAll('.card-swatch-list, fieldset.h-stack').forEach(function (container) {
      // All visible (non-overflow-hidden) swatch labels in this container
      var allVisible = Array.from(
        container.querySelectorAll('.color-swatch:not(.cs-overflow-hidden)')
      );
      var totalVisible = allVisible.length;

      // Total including Liquid-hidden ones
      var totalSwatches =
        totalVisible +
        container.querySelectorAll('.color-swatch.cs-overflow-hidden').length;

      var desktopPill = container.querySelector('.cs-overflow-pill');
      var mobilePill = container.querySelector('.cs-overflow-pill--mobile');

      if (isMobile) {
        // How many are hidden on mobile = total minus mobile max (minimum 0)
        var mobileOverflow = Math.max(0, totalSwatches - MOBILE_MAX);

        // Remove stale mobile pill
        if (mobilePill) mobilePill.remove();

        if (mobileOverflow > 0) {
          var pill = document.createElement('span');
          pill.className = 'cs-overflow-pill--mobile';
          pill.setAttribute('aria-hidden', 'true');
          pill.textContent = '+' + mobileOverflow;
          container.appendChild(pill);
        }
      } else {
        // Desktop: remove any mobile pill, let the Liquid pill show
        if (mobilePill) mobilePill.remove();
      }
    });
  }

  // Run on load and on resize (debounced)
  document.addEventListener('DOMContentLoaded', updateSwatchPills);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateSwatchPills, 150);
  });
})();
